import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import SubmitDocumentsModal from 'SubmitDocumentsModal';
import PhaseType from 'types/phase';
import TaskType from 'types/task';
import { updatePhaseTask } from 'actionCreators/phase';
import PhaseTask from './phase_task';

export class SubmitDocuments extends PhaseTask {
  onClick = () => {
    if (this.props.task.status === 'complete') this.toggleStatus();
    else this.setState({ modalActive: true });
  }

  renderChildren = () => <SubmitDocumentsModal
    phase={this.props.phase}
    task={this.props.task}
    active={this.state.modalActive}
    updatePhaseTask={this.props.updatePhaseTask}
    onClose={this.handleClose}
  />
}

SubmitDocuments.propTypes = {
  phase: PhaseType.isRequired,
  task: TaskType.isRequired,
  updatePhaseTask: PropTypes.func.isRequired,
};

const workorder_upload_docs = connect(
  () => ({}), { updatePhaseTask },
)(SubmitDocuments);

export { workorder_upload_docs };



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/components/tasks/workorder_upload_docs.jsx